import { render, staticRenderFns } from "./StudentHistory.vue?vue&type=template&id=a537aeac&scoped=true&"
import script from "./StudentHistory.vue?vue&type=script&lang=js&"
export * from "./StudentHistory.vue?vue&type=script&lang=js&"
import style0 from "./StudentHistory.vue?vue&type=style&index=0&id=a537aeac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a537aeac",
  null
  
)

export default component.exports